import { Component, Input, OnChanges, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { InternalFilterGroup, FilterItem } from 'app/shared/models/filter-group.models';
import { SearchSettings } from 'app/back-office/shared/models/common/search-settings.model';
import { SettingService } from 'app/back-office/shared/services/back-office/setting.service';
import { FilterMapper } from 'app/back-office/shared/utilities/filter-mapper';
import { UtilityFunctions } from 'app/shared/utilities/functions.models';
import { TierAvailabilityStatus } from 'app/back-office/shared/models/settings/tier.model';

@Component({
    selector: 'app-tier-filter',
    templateUrl: './tier-filter.component.html',
    styleUrls: ['./tier-filter.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TierFilterComponent implements OnInit, OnChanges {
  @Input() filter: InternalFilterGroup;
  @Input() accordionState: boolean;

  loaderId = UtilityFunctions.newGuid();
  searchSettings: SearchSettings = {
    placeholder: 'Search name...',
    inputId: UtilityFunctions.newGuid(),
    showFilters: false,
  };

  totalCount = 0;
  searchValue = '';
  cacheFilterData: FilterItem[];
  dataToView: FilterItem[] = [new FilterItem({ text: 'STATUS.ALL', value: null })];
  constructor(private settingService: SettingService) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.accordionState && this.accordionState && this.dataToView.length === 1) {
      this.setDataToView(0);
    }
  }

  ngOnInit(): void {
  }

  onSearch(search: string) {
    this.searchValue = search;
    if (search === '') this.dataToView = [new FilterItem({ text: 'STATUS.ALL', value: null })];
    this.setDataToView(0);
  }

  setDataToView(skipCount: number) {
    this.settingService.getTiers(this.loaderId, skipCount, 20, this.searchValue, null, TierAvailabilityStatus.actives).subscribe(res => {
      this.dataToView = res.items.map(el => FilterMapper.TierFilter(el));
      this.totalCount = res.totalCount + 1;
    });
  }

  getNextData(skipCount: number) {
    if (this.totalCount > skipCount) {
      const next = skipCount ? skipCount - 1 : skipCount;
      this.setDataToView(next);
    }
  }

}
